import { Typography } from '@mui/material';
import { tss } from 'tss-react/mui';

const useStyles = tss.create({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '10em',
  },
});

export const FileManagerFileNotFound = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Typography variant="h6">
        We can&apos;t find this file or folder
      </Typography>
      <Typography variant="caption">
        It may have been deleted or had its visibility restricted
      </Typography>
    </div>
  );
};
